import React from "react";
import Image from "next/image";
import styles from "./styles.module.scss";
import cn from "classnames";
import useWindowWidth from "hooks/useWindowWidth";
import { track } from "utils/amplitude";

const ReviewContainer = ({ description, src, title }) => {
  const width = useWindowWidth();

  const handleLinkClick = () => {
    track("page_external_link_clicked", {
      target_url: "https://apphud.com/blog/infrastructure-case-study",
    });
    window.open(
      "https://apphud.com/blog/infrastructure-case-study",
      "_blank",
      "noopener noreferrer"
    );
  };

  return (
    <div>
      <div className={styles.container} onClick={handleLinkClick}>
        <div>
          <div className={styles.description}>{description}</div>
          <div className={styles.author}>
            <Image
              width={width > 992 ? 56 : 42}
              height={width > 992 ? 56 : 42}
              src={src}
            />
            <div className={styles.title_container}>
              <div className={cn("title_xs", "font_regular")}>{title}</div>
              <div className={styles.tag}>5X revenue growth</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewContainer;
